import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { NamedView } from "@common/types/views/views";
import { TransactionView } from "@common/types/views/transactionViews";
import { createDefaultGLDrillDownTransactionView } from "@components/transactions/views/DefaultGLDrillDownTransactionView";
import { WORKSPACE_USER_CACHE_KEYS } from "@hooks/useWorkspaceUserCache";

export interface GlTransactionsDrilldownConfig {
    createView: (
        ledgerBasis: AccountingLedgerBasis | undefined,
        options: { isClassesEnabled: boolean },
    ) => NamedView<TransactionView>;
    getCacheKey: (
        ledgerBasis: AccountingLedgerBasis,
    ) => WORKSPACE_USER_CACHE_KEYS;
}

export const defaultGlTransactionsDrilldown: GlTransactionsDrilldownConfig = {
    createView: createDefaultGLDrillDownTransactionView,
    getCacheKey: (ledgerBasis) =>
        ledgerBasis === AccountingLedgerBasis.accruals
            ? WORKSPACE_USER_CACHE_KEYS.GENERAL_LEDGER_ACCRUAL_TRANSACTIONS_DRILLDOWN_VIEW_CACHE_KEY
            : WORKSPACE_USER_CACHE_KEYS.GENERAL_LEDGER_CASH_TRANSACTIONS_DRILLDOWN_VIEW_CACHE_KEY,
};
